import { render, staticRenderFns } from "./aftersale_person.vue?vue&type=template&id=3c13e425&scoped=true"
import script from "./aftersale_person.vue?vue&type=script&lang=js"
export * from "./aftersale_person.vue?vue&type=script&lang=js"
import style0 from "./aftersale_person.vue?vue&type=style&index=0&id=3c13e425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13e425",
  null
  
)

export default component.exports